import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { POSITION, useToast } from "vue-toastification";
  import { EstateInterface } from "@/types/EstateInterface";
  import { ReportsTimePeriod } from "@/enums/ReportsTimePeriod";
  import { formatPrice } from "@/helpers/transformation/price";
  import { formatDate } from "@/helpers/date";
  import InitialHoldStatus from "@/enums/initialHoldStatus";
  import { HoldsReportInterface } from "@/types/AnalyticsHoldsReportInterface";
  import { filterByPeriod } from "@/helpers/analytics/filterByPeriod";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HoldsCancelled',
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    searchKey: {
      type: Number,
      required: true,
    },
    estateSelected: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const store = useStore();
  const toast = useToast();
  const loading = ref(false);

  const holdsByReport = ref<HoldsReportInterface[]>([]);

  const landownerId = computed(() => store.state.user.data._id);

  const startDateSelected = computed(() => {
    return props.startDate;
  });

  const endDateSelected = computed(() => {
    return props.endDate;
  });

  const estateSelected = computed(() => {
    return props.estateSelected;
  });

  watch(
    () => props.searchKey,
    () => {
      getlotStatus();
    }
  );

  const getlotStatus = () => {
    loading.value = true;

    if (landownerId.value) {
      store
        .dispatch("analytics/getInitialHold", {
          landownerId: landownerId.value,
          status: InitialHoldStatus.CANCELLED,
          estateSelected: estateSelected.value,
        })
        .then((res) => {
          const filteredHolds = filterByPeriod(
            res.data,
            startDateSelected.value,
            endDateSelected.value
          );

          holdsByReport.value = filteredHolds;
        })
        .catch((err) => {
          toast.error("Error getting holds cancelled", {
            position: POSITION.TOP_LEFT,
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }
  };

  onMounted(() => {
    getlotStatus();
  });

const __returned__ = { props, store, toast, loading, holdsByReport, landownerId, startDateSelected, endDateSelected, estateSelected, getlotStatus, ref, onMounted, computed, watch, get useStore() { return useStore }, get POSITION() { return POSITION }, get useToast() { return useToast }, get EstateInterface() { return EstateInterface }, get ReportsTimePeriod() { return ReportsTimePeriod }, get formatPrice() { return formatPrice }, get formatDate() { return formatDate }, get InitialHoldStatus() { return InitialHoldStatus }, get HoldsReportInterface() { return HoldsReportInterface }, get filterByPeriod() { return filterByPeriod } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})